import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-009bc382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-progress" }
const _hoisted_2 = { class: "upload-progress__modal" }
const _hoisted_3 = { class: "upload-progress__container" }
const _hoisted_4 = {
  key: 0,
  class: "upload-progress__dots"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "a",
    class: "circle"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "b",
    class: "circle"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "c",
    class: "circle"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "upload-progress__checkmark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ion_progress_bar, {
          value: _ctx.uploadProgress,
          class: "upload-progress__bar"
        }, null, 8, ["value"]),
        (_ctx.uploadProgress !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.uploadProgress === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "✓"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}